import { Fragment, useCallback, useEffect, useState } from "react";
import { api } from "../../services";
import {
  BodyModal,
  ContainerModal,
  HeaderModal,
  OverLay,
} from "../header/styles";
import LogoWhite from "./assets/logoWhite.png";
import IconTel from "./assets/telefone.svg";
import IconCLoseDArk from "../../assets/icones/icons dense (24px)/fechar.svg";
import { IconSocial } from "./constants";
import {
  AreaBottomFooter,
  AreaLeftFooter,
  AreaRightFooter,
  ContentLeftFooter,
  FooterContainer,
  FooterContainerMobile,
  IconSocialItem,
  InfosMenuFooter,
  ItensMenuFooter,
  ItensMenuFooterOther,
  ParagraphItemFooter,
  TextBottomFooter,
  TitleInfo,
  WrapperAtendance,
  WrapperContentInfosLeft,
  WrapperIconSocial,
  WrapperInfoRightUserMobile,
  WrapperInfosLeft,
  WrapperInfosRight,
  WrapperPhone,
} from "./styles";
import useCreateToken from "../../hooks/createToken";
import Cookie from "js-cookie";
import ModalFirstAccess from "../FirstAccess";
import NewsletterInput from "../NewsletterInput";
import LoginForm from "../LoginForm";
import ForgotPasswordForm from "../ForgotPasswordForm";

const Footer = () => {
  const [modalLogin, setModalLogin] = useState<boolean>(false);
  const [forgotPassOpen, setForGottPassOpen] = useState<boolean>(false);
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const idUser = localStorage.getItem("assnic");
  const token = localStorage.getItem("token");
  // const [nameUser, setNameUser] = useState<string>("");
  // const [avatar, setAvatar] = useState<string>("");

  const [openFirstAccess, setOpenFirstAccess] = useState<boolean>(false);
  const idUserHotelier = localStorage.getItem("IdUserHotelier");

  const { tokenApi } = useCreateToken();

  const handleToggleModallogin = () => {
    setModalLogin(!modalLogin);
    setForGottPassOpen(false);
    setOpenFirstAccess(false);
    //setOpenOptionsLogin(false);
  };

  const handleFirstAccess = () => {
    setOpenFirstAccess(true);
    setModalLogin(false);
  };

  const handleCloseFirstAccess = () => {
    setModalLogin(false);
    setOpenFirstAccess(false);
  };

  const handleRedirectIsLogged = () => {
    if (isLogged) {
      window.location.href = `https://www.coobmais.com.br/portal_associado.html#/minhasReservas`;
      return;
    }
  };

  const handleRedirectIsLoggedReserve = () => {
    if (isLogged) {
      window.location.href = `https://www.coobmais.com.br/portal_associado.html#/minhasReservas`;
      return;
    }
  };

  const handlePU1 = useCallback(
    async (assNic: string) => {
      const resp = await api.post(`/wsCoobrastur/ConsultaHoteis.asmx/PU_1`, {
        nic: assNic,
      });
      if (resp.status === 200) {
        setCookies(tokenApi, resp.data[0].assnome_razaosocial, assNic, 1);
        setIsLogged(true);
        return;
      }
      console.error(resp.data);
    },
    [tokenApi]
  );
  const handleIsLogged = useCallback(
    async (assNic: string) => {
      setIsLogged(true);
      try {
        await handlePU1(assNic);
      } catch (err) {
        console.error(err);
      }
    },
    [handlePU1]
  );

  const handleSuccessLogin = async ({ assNic }: { assNic: string }) => {
    await handlePU1(assNic);
    setIsLogged(true);
    handleToggleModallogin();
    window.location.href = `https://www.coobmais.com.br/portal_associado.html#/minhasReservas`;
  };

  const setCookies = (
    token: string,
    userName: string,
    id: string,
    level: number
  ) => {
    const data = {
      currentUser: {
        token: token,
        nomePessoa: userName,
        assnic: id,
        nivelUser: level,
      },
    };
    Cookie.set("usuario_coob", JSON.stringify(data), { expires: 1 });
  };

  const handleForGotPassword = () => {
    setForGottPassOpen(true);
  };

  useEffect(() => {
    if (idUser !== null) {
      handleIsLogged(idUser);
    }

    if (idUserHotelier !== null) {
      const nameUseHotelier = localStorage.getItem("nameUserHotelier");
      if (nameUseHotelier) {
        // setNameUser(nameUseHotelier);
        setIsLogged(true);
        return;
      }
    }
  }, [idUser, idUserHotelier, handleIsLogged]);

  return (
    <Fragment>
      {modalLogin && (
        <OverLay>
          <ContainerModal>
            <HeaderModal>
              <span>
                {!forgotPassOpen ? "acessar sua conta" : "redefinir senha"}
              </span>
              <img
                src={IconCLoseDArk}
                alt="fechar-modal"
                onClick={handleToggleModallogin}
              />
            </HeaderModal>

            {!forgotPassOpen && (
              <BodyModal>
                <LoginForm
                  onSuccessLogin={handleSuccessLogin}
                  tokenApi={token || tokenApi}
                  onClickFirstAccess={handleFirstAccess}
                  onClickForgotPassword={handleForGotPassword}
                />
              </BodyModal>
            )}
            {forgotPassOpen && (
              <BodyModal>
                <ForgotPasswordForm
                  tokenApi={tokenApi}
                  onClickLogin={() => setForGottPassOpen(false)}
                />
              </BodyModal>
            )}
          </ContainerModal>
        </OverLay>
      )}
      {openFirstAccess && <ModalFirstAccess onClose={handleCloseFirstAccess} />}
      <FooterContainer>
        <AreaLeftFooter>
          <ContentLeftFooter>
            <img src={LogoWhite} alt="logo-coob" style={{ width: 300 }} />
            <NewsletterInput />
          </ContentLeftFooter>
        </AreaLeftFooter>
        <AreaRightFooter>
          <WrapperInfosLeft>
            <TitleInfo>Sobre Nós</TitleInfo>
            <ItensMenuFooter to={`${process.env.PUBLIC_URL}/sobreaempresa`}>
              A Coob+
            </ItensMenuFooter>
            <ItensMenuFooter to={`${process.env.PUBLIC_URL}/comofunciona`}>
              Como funciona
            </ItensMenuFooter>
            <ItensMenuFooter to={`${process.env.PUBLIC_URL}/politicadeuso`}>
              Políticas de uso
            </ItensMenuFooter>
            <ItensMenuFooter to={`${process.env.PUBLIC_URL}/seguranca`}>
              Confiança e segurança
            </ItensMenuFooter>
            {/* <ItensMenuFooterOther
              href="https://www.coobmais.com.br/info.html#/trabalhe-conosco"
              target="_blank"
            >
              Trabalhe Conosco
            </ItensMenuFooterOther> */}
            <ItensMenuFooter to={`${process.env.PUBLIC_URL}/Ajuda`}>
              Ajuda
            </ItensMenuFooter>
            <ItensMenuFooterOther
              href="https://viajantecoobmais.com.br/"
              target="_blank"
            >
              Veja nosso blog
            </ItensMenuFooterOther>
            <TitleInfo>Assinante</TitleInfo>
            <div
              onClick={
                isLogged ? handleRedirectIsLogged : handleToggleModallogin
              }
            >
              Acesse sua conta
            </div>
            <div
              onClick={
                isLogged
                  ? handleRedirectIsLoggedReserve
                  : handleToggleModallogin
              }
            >
              Minhas reservas
            </div>
            <ItensMenuFooterOther
              href="https://www.coobmais.com.br/indiquemais/"
              target="_blank"
            >
              Indique mais
            </ItensMenuFooterOther>
            <TitleInfo>Seja Coob+</TitleInfo>
            <ItensMenuFooterOther
              href="https://www.coobmais.com.br/ecommerce/"
              target="_blank"
            >
              Associe-se
            </ItensMenuFooterOther>
            {/* <ItensMenuFooterOther
              href="https://www.coobmais.com.br/hotel-credenciado/#/"
              target="_blank"
            >
              Seja um Hotel Credenciado
            </ItensMenuFooterOther> */}
          </WrapperInfosLeft>

          <WrapperInfosRight>
            <TitleInfo>Atendimento ao Assinante</TitleInfo>
            <ParagraphItemFooter>Central de Atendimento</ParagraphItemFooter>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(11) 3192-2020</InfosMenuFooter>
            </WrapperPhone>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(61) 3770-0400</InfosMenuFooter>
            </WrapperPhone>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(31) 2116-5770</InfosMenuFooter>
            </WrapperPhone>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(81) 3787-7660</InfosMenuFooter>
            </WrapperPhone>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(51) 3018-6900</InfosMenuFooter>
            </WrapperPhone>
            <ParagraphItemFooter>Cobrança</ParagraphItemFooter>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(54) 3278-9899</InfosMenuFooter>
            </WrapperPhone>
            <TitleInfo>Agência Parceira Credenciada</TitleInfo>
            <ParagraphItemFooter>Nacional turismo</ParagraphItemFooter>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(54) 3278-9880</InfosMenuFooter>
            </WrapperPhone>
            <WrapperPhone>
              <img src={IconTel} alt="telefone" />
              <InfosMenuFooter>(81) 3202-1440</InfosMenuFooter>
            </WrapperPhone>
          </WrapperInfosRight>
        </AreaRightFooter>
        <AreaBottomFooter>
          <TextBottomFooter>
            <h5>Siga a COOb+</h5> nas redes sociais!
          </TextBottomFooter>
          <WrapperIconSocial>
            {IconSocial.map(({ icon, id, name, link }) => (
              <a href={link} target="_blanck" key={id}>
                <IconSocialItem src={icon} alt={name} />
              </a>
            ))}
          </WrapperIconSocial>
        </AreaBottomFooter>
      </FooterContainer>
      <FooterContainerMobile>
        <img src={LogoWhite} alt="logo-coob" style={{ width: 300 }} />
        <TextBottomFooter>
          <h5>Siga a COOb+</h5> nas redes sociais!
        </TextBottomFooter>
        <WrapperIconSocial>
          {IconSocial.map(({ icon, id, name, link }) => (
            <a href={link} target="_blanck" key={id}>
              <IconSocialItem src={icon} alt={name} />
            </a>
          ))}
        </WrapperIconSocial>
        <ContentLeftFooter>
          <NewsletterInput />
        </ContentLeftFooter>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WrapperContentInfosLeft>
            <WrapperInfosLeft>
              <TitleInfo>Sobre Nós</TitleInfo>
              <ItensMenuFooter to={`${process.env.PUBLIC_URL}/sobreaempresa`}>
                A Coob+
              </ItensMenuFooter>
              <ItensMenuFooter to={`${process.env.PUBLIC_URL}/comofunciona`}>
                Como funciona
              </ItensMenuFooter>
              <ItensMenuFooter to={`${process.env.PUBLIC_URL}/politicadeuso`}>
                Políticas de uso
              </ItensMenuFooter>
              <ItensMenuFooter to={`${process.env.PUBLIC_URL}/seguranca`}>
                Confiança e segurança
              </ItensMenuFooter>
              {/* <ItensMenuFooterOther
                href="https://www.coobmais.com.br/info.html#/trabalhe-conosco"
                target="_blank"
              >
                Trabalhe Conosco
              </ItensMenuFooterOther> */}
              <ItensMenuFooter to={`${process.env.PUBLIC_URL}/Ajuda`}>
                Ajuda
              </ItensMenuFooter>
              <ItensMenuFooterOther
                href="https://viajantecoobmais.com.br/"
                target="_blank"
              >
                Veja nosso blog
              </ItensMenuFooterOther>
            </WrapperInfosLeft>
            <WrapperInfosLeft>
              <TitleInfo>Agência Parceira Credenciada</TitleInfo>
              <ParagraphItemFooter>Nacional turismo</ParagraphItemFooter>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(54) 3278-9880</InfosMenuFooter>
              </WrapperPhone>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(81) 3202-1440</InfosMenuFooter>
              </WrapperPhone>
            </WrapperInfosLeft>
          </WrapperContentInfosLeft>
          <WrapperInfosRight>
            <WrapperInfoRightUserMobile>
              <TitleInfo>Assinante</TitleInfo>
              <div
                onClick={
                  isLogged ? handleRedirectIsLogged : handleToggleModallogin
                }
                style={{ fontSize: "0.8rem" }}
              >
                Acesse sua conta
              </div>
              <div
                style={{ fontSize: "0.8rem" }}
                onClick={
                  isLogged
                    ? handleRedirectIsLoggedReserve
                    : handleToggleModallogin
                }
              >
                Minhas reservas
              </div>
              <ItensMenuFooterOther
                href="https://www.coobmais.com.br/indiquemais/"
                target="_blank"
              >
                Indique mais
              </ItensMenuFooterOther>
              <TitleInfo>Seja Coob+</TitleInfo>
              <ItensMenuFooterOther
                href="https://www.coobmais.com.br/ecommerce/"
                target="_blank"
              >
                Associe-se
              </ItensMenuFooterOther>
              {/* <ItensMenuFooterOther
                href="https://www.coobmais.com.br/hotel-credenciado/#/"
                target="_blank"
              >
                Seja um Hotel Credenciado
              </ItensMenuFooterOther> */}
            </WrapperInfoRightUserMobile>
            <WrapperAtendance>
              <TitleInfo id="attendencTitle">
                Atendimento ao Assinante{" "}
              </TitleInfo>
              <ParagraphItemFooter id="attendenceCenter">
                Central de Atendimento
              </ParagraphItemFooter>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(11) 3192-2020</InfosMenuFooter>
              </WrapperPhone>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(61) 3770-0400</InfosMenuFooter>
              </WrapperPhone>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(31) 2116-5770</InfosMenuFooter>
              </WrapperPhone>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(81) 3787-7660</InfosMenuFooter>
              </WrapperPhone>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(51) 3018-6900</InfosMenuFooter>
              </WrapperPhone>
              <ParagraphItemFooter>Cobrança</ParagraphItemFooter>
              <WrapperPhone>
                <img src={IconTel} alt="telefone" />
                <InfosMenuFooter>(54) 3278-9899</InfosMenuFooter>
              </WrapperPhone>
            </WrapperAtendance>
          </WrapperInfosRight>
        </div>
      </FooterContainerMobile>
    </Fragment>
  );
};

export default Footer;
